import { EVENT_KEYS, STATUS } from "./constants";

export const getProgramId = (program) => program?.id || program?._id || null;

export const formatStatus = (status) => {
  if (status === STATUS.ACTIVE) return "Active";
  if (status === STATUS.INACTIVE) return "Inactive";
  return status || "—";
};

export const toInputValue = (value) => (value == null ? "" : String(value));

export const isStreakEnabled = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "yes" || normalized === "true" || normalized === "1";
  }
  return false;
};

export const getApiErrorMessage = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

export const mapProgramRow = (program, index) => ({
  ...program,
  id: getProgramId(program) ?? `program-${index}`,
});

export const createEventChunk = () => ({
  id: Date.now() + Math.random(),
  event_key: EVENT_KEYS[0].value,
  event_name_en: "",
  event_name_hi: "",
  description_en: "",
  description_hi: "",
  coins: "",
  min_action: "1",
  condition_1_key: "",
  condition_1: "",
  condition_1_value: "",
  condition_2_key: "",
  condition_2: "",
  condition_2_value: "",
  is_streak: false,
  streak_duration: "",
  streak_coins: "",
});

export const mapApiEventToChunk = (event, index) => ({
  id: event.id != null ? `event-${event.id}` : `event-new-${index}-${Date.now()}`,
  eventId: event.id || null,
  event_key: event.event_key || EVENT_KEYS[0].value,
  event_name_en: toInputValue(event.event_name_en),
  event_name_hi: toInputValue(event.event_name_hi),
  description_en: toInputValue(event.description_en),
  description_hi: toInputValue(event.description_hi),
  coins: toInputValue(event.coins),
  min_action: toInputValue(event.min_action) || "1",
  condition_1_key: toInputValue(event.condition_1_key),
  condition_1: toInputValue(event.condition_1),
  condition_1_value: toInputValue(event.condition_1_value),
  condition_2_key: toInputValue(event.condition_2_key),
  condition_2: toInputValue(event.condition_2),
  condition_2_value: toInputValue(event.condition_2_value),
  is_streak: isStreakEnabled(event.is_streak),
  streak_duration: toInputValue(event.streak_duration),
  streak_coins: toInputValue(event.streak_coins),
});

export const mapApiEventForReorder = (event, index) => ({
  id: event.id ?? event.event_id ?? `event-${index}`,
  eventId: event.id ?? event.event_id ?? null,
  titleEn: event.event_name_en || event.title_en || "",
  titleHi: event.event_name_hi || event.title_hi || "",
});

export const nextProgramStatus = (status) =>
  status === STATUS.ACTIVE ? STATUS.INACTIVE : STATUS.ACTIVE;
